export default class CountDownTrigger {
    /**
     * @param countDownTo
     */
    constructor(countDownTo) {
        this.countDownTo = countDownTo;
    }

    /**
     * @returns void
     */
    start() {
        let self = this;

        // Set the date we're counting down to
        let countDownDate = new Date(
            this.countDownTo.Y,
            this.countDownTo.m - 1,
            this.countDownTo.d,
            this.countDownTo.H,
            this.countDownTo.i,
            this.countDownTo.s
        ).getTime();

        let i = 0;

        // Update the count down every 1 second
        let x = setInterval(function() {

            // Get today's date and time
            let now = new Date().getTime();

            // Find the distance between now and the count down date
            let distance = countDownDate - now;

            let countdownFinished = distance < 0;

            let header = jQuery('body header');

            // If the count down is finished, do nothing
            if (countdownFinished) {
                clearInterval(x);
                header.find('.countdown-timer').css('visibility','hidden');
            }

            // Time calculations for days, hours, minutes and seconds
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = self.explodeNumbers(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + (days * 24)));
            let minutes = self.explodeNumbers(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
            let seconds = self.explodeNumbers(Math.floor((distance % (1000 * 60)) / 1000));

            header.find('.hrs10s').text(hours[0]);
            header.find('.hrs1s').text(hours[1]);
            header.find('.min10s').text(minutes[0]);
            header.find('.min1s').text(minutes[1]);
            header.find('.sec10s').text(seconds[0]);
            header.find('.sec1s').text(seconds[1]);

            if (i === 0 && !countdownFinished) {
                header.find('.countdown-timer').css('visibility','visible').hide().fadeIn('fast');
            }
            i++;
        }, 1000);
    }
    /**
     * @param number
     * @returns {*[]}
     */
    explodeNumbers(number) {
        let output = [];
        let sNumber = number.toString();
        for (let i = 0, len = sNumber.length; i < len; i += 1) {
            output.push(+sNumber.charAt(i));
        }
        if (output.length === 1) {
            // Add zero to the first index of the array
            output.unshift(0);
        }
        return output;
    }
}
